export const update = {
  form: {
    name: '洗剤名',
    price: '仕入れ金額(円)',
    netWeightG: '内容量(重量:g)',
    netWeightMl: '内容量(容量:ml)',
    specificGravity: '比重',
    costPerMl: '1ml当たり原価(円)',
    remainingQuantity: '在庫数量(ケース)',
    thresholdQuantity: 'アラート設定数量(ケース)',
    g: 'g',
    ml: 'ml',
    bin: 'ケース',
    tankInfo: '使用洗剤タンク',
    tankNo: '洗剤 No.',
    requireName: '洗剤名を入力してください',
    requirePrice: '仕入れ金額(円)を入力してください',
    requireQuantity: '数量を入力してください',
    requireRemainingQuantity: '在庫数量(ケース) を入力してください',
    requireUnit: '単位を入力してください',
    requireAnnouncements: '通知レベルを選択してください',
    requireSpecificGravity: '比重を入力してください',
    requireCostPerMl: '1ml当たり原価(円)を入力してください',
    requireThresholdQuantity: 'アラート設定数量(ケース) を入力してください',
    requireNetWeightG: '内容量（g）を入力してください',
    requireNetWeightMl: '内容量（ml）を入力してください',
    invalidLetters: '文字のみ入力できます。',
    invalidNumbers: '数字のみ入力できます。',
    cancel: 'キャンセル',
    update: '保存',
  },
  pageHeader: {
    title: '洗剤リスト　洗剤情報編集画面',
    back: '戻る',
  },
}
